'use client';

import { tv } from 'tailwind-variants';

import { SearchInput } from './search-input.component';

import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import {
  ProgressiveSearchModalKeys,
  SelectedProcedures,
} from '@/app/(main)/_components/search-modal/search-modal.types';

export { ProgressiveSearchModalKeys };
export type { SelectedProcedures };

const searchStyle = tv({
  slots: {
    container: 'z-30 sticky top-0 bg-white',
  },
});

function SearchTrigger({ children }: { children?: React.ReactNode }) {
  if (!children) {
    return <SearchInput className="border-green-200" />;
  }

  return children;
}

interface SearchProps {
  className?: string;
  styleType?: 'sticky' | 'flat';
  children?: React.ReactNode;
  triggerClassName?: string;
  disableRenderInputWithModal?: boolean;
}

export function Search({
  className,
  triggerClassName,
  children,
  styleType = 'sticky',
}: SearchProps) {
  const { container } = searchStyle();

  if (styleType === 'flat') {
    return (
      <div
        onClick={() => {
          handleOpenSearchModal();
        }}
        data-testid="search-section"
        className={triggerClassName}
      >
        {children || <SearchTrigger />}
      </div>
    );
  }

  return (
    <div id="home-search-bar" className={container({ className })} data-testid="search-section">
      <section className="px-5 py-3 hidden">
        <div className="z-30 sticky top-14">
          <SearchInput />
        </div>
      </section>
    </div>
  );
}

Search.Trigger = SearchTrigger;
